export const CREATE_BUDGET = 'createBudget';
export const FETCH_BUDGET_BY_ID = 'fetchBudgetById';
export const FETCH_PROJECT_BUDGETS = 'fetchProjectBudgets';
export const DELETE_BUDGET_BY_ID = 'deleteBudgetById';
